import actions from './actions';

const initialState = {
    bitacoras: [],
    bitacoraActual: null,
    reparacionesBitacora: {
        reparaciones: [],
        bitacoraId: null,
    },
    loadingBitacoras: false,
    loadingBitacoraActual: false,
    loadingReparaciones: false,
    loadingAlertas: false,
    alertasReparaciones: {},
};

export default function bitacorasReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_BITACORAS_REQUEST:
            return {
                ...state,
                loadingBitacoras: true,
            }
        case actions.GET_BITACORAS_SUCCESS:
            return {
                ...state,
                loadingBitacoras: false,
                bitacoras: action.payload
            }
        case actions.GET_BITACORA_BY_ID_REQUEST:
            return {
                ...state,
                loadingBitacoraActual: true,
            }
        case actions.GET_BITACORA_BY_ID_SUCCESS:
            return {
                ...state,
                loadingBitacoraActual: false,
                bitacoraActual: action.payload,
            }
        case actions.GET_REPARACIONES_REQUEST:
            return {
                ...state,
                loadingReparaciones: true,
            }
        case actions.GET_REPARACIONES_SUCCESS:
            return {
                ...state,
                loadingReparaciones: false,
                reparacionesBitacora: action.payload
            }
        case actions.CREATE_REPARACION_SUCCESS:
            return {
                ...state,
                reparacionesBitacora: {
                    ...state.reparacionesBitacora,
                    reparaciones: [action.payload, ...state.reparacionesBitacora.reparaciones]
                }
            }
        case actions.GET_ALERTAS_BITACORAS_REQUEST:
            return {
                ...state,
                loadingAlertas: true,
            }
        case actions.GET_ALERTAS_BITACORAS_SUCCESS:
            return {
                ...state,
                loadingAlertas: false,
                alertasReparaciones: action.payload
            }
        // case actions.DELETE_BITACORA_REQUEST:
        //     return {
        //         ...state,
        //         loadingBitacoras: true,
        //     }
        // case actions.DELETE_BITACORA_SUCCESS:
        //     return {
        //         ...state,
        //         bitacoras: state.bitacoras.filter(bitacora => bitacora._id !== action.payload.data._id),
        //         loadingBitacoras: false,
        //     }
        default:
            return state;
    }
}